<template>
  <Modal :setModalStyle="setModalStyle">
    <div slot="header" class="modal_header">
      <div class="modal_imgWrap">
        <img :src="require(`@/assets/images/${modalImg}`)">
      </div>
      <div class="modal_closeBtn" v-if="closeType === 'close'">
        <img src="@/assets/images/x_popup.svg" @click.prevent="SET_POPUP_HEADER_MAIN(false)">
      </div>
      <div class="modal_closeBtn" v-if="closeType === 'action'">
        <img src="@/assets/images/x_popup.svg" @click.prevent="closeAction()">
      </div>
      <div class="modal_closeBtn" v-if="closeType === 'mobileAction'">
        <img src="@/assets/images/x_popup.svg" @click.prevent="mobileAction()">
      </div>
      <div class="modal_closeBtn" v-if="closeType === 'mobileDeleteAuth'">
        <img src="@/assets/images/x_popup.svg" @click.prevent="mobileDeleteAuth()">
      </div>
    </div>
    <div slot="body">
      <p>{{modalBody}}</p>
    </div>
    <div slot="footer" v-if="count === 'single'">
      <div class="modal_btnWrap single">
        <button class="btn confirm" :type="btnType" @click.prevent="SET_POPUP_HEADER_MAIN(false)" v-text="confirmBtnText"></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'double'">
      <div class="modal_btnWrap double">
        <button class="btn cancel" @click.prevent="SET_POPUP_HEADER_MAIN(false)" v-text="cancelBtnText">취소</button>
        <button class="btn confirm" :type="btnType" v-text="confirmBtnText" @click.prevent="btnMove()"></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'triple'">
      <div class="modal_btnWrap triple">
        <button class="btn cancel" @click.prevent="SET_POPUP_HEADER_MAIN(false)" v-text="cancelBtnText">취소</button>
        <button class="btn confirm" :type="btnType" v-text="confirmBtnText" @click.prevent="btnMove()"></button>
      </div>
        <div class="modal_outSide" v-if="outSide === true">
          <div class="mo_imgWrap">
            <img src="@/assets/images/call.svg">
          </div>
          <button class="btn" :type="btnType" v-text="anotherBtnText" @click.prevent="btnMove_another()"></button>
        </div>
    </div>
    <div slot="footer" v-if="count === 'another'">
      <div class="modal_btnWrap single">
        <button class="btn confirm" :type="btnType" @click.prevent="btnMoveClosed()" v-text="confirmBtnText"></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'deploy'">
      <div class="modal_btnWrap single">
        <button class="btn confirm" :type="btnType" @click.prevent="btnMoveDeploy()" v-text="confirmBtnText"></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'mobileAction'">
      <div class="modal_btnWrap single">
        <button class="btn confirm" :type="btnType"  @click.prevent="mobileAction()" v-text="confirmBtnText"></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'mobileDeleteAuth'">
      <div class="modal_btnWrap single">
        <button class="btn confirm" :type="btnType"  @click.prevent="mobileDeleteAuth()" v-text="confirmBtnText"></button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex'
import Modal from './Modal.vue'
import { getCookie } from '../utils/cookieNew'

export default {
  props: {
    popupSetMain: {
      title: '',
      modalImg: {
        type: String
      },
      content: {
        type: String
      },
      confirmBtnText: {
        type: String
      },
      cancelBtnText: {
        type: String
      },
      anotherBtnText: {
        type: String
      },
      btnType: {
        type: String
      },
      count: {
        type: String,
        default: 'double'
      },
      outSide: {
        default: false
      },
      nextLink: {
        type: String
      },
      nextLink_another: {
        type: String
      },
      bigModal: {
        default: false
      },
      longHeight: {
        default: false
      },
      topImg: {
        default: false
      },
      closeType: {
        type: String,
        default: 'close'
      },
      closeLink: {
        type: String,
        default: '/'
      },
      mobileLink: {
        type: String
      }
    }
  },
  components: {
    Modal
  },
  data () {
    return {
      input: '',
      valid: false,
      modalImg: this.popupSetMain.modalImg,
      modalBody: this.popupSetMain.content,
      confirmBtnText: this.popupSetMain.confirmBtnText,
      cancelBtnText: this.popupSetMain.cancelBtnText,
      anotherBtnText: this.popupSetMain.anotherBtnText,
      btnType: this.popupSetMain.btnType,
      count: this.popupSetMain.count,
      outSide: this.popupSetMain.outSide,
      nextLink: this.popupSetMain.nextLink,
      nextLink_another: this.popupSetMain.nextLink_another,
      closeType: this.popupSetMain.closeType,
      closeLink: this.popupSetMain.closeLink,
      setModalStyle: {
        bigModal: this.popupSetMain.bigModal,
        longHeight: this.popupSetMain.longHeight,
        topImg: this.popupSetMain.topImg,
        specialPick: this.popupSetMain.specialPick
      },
      mobileLink: this.popupSetMain.mobileLink
    }
  },
  watch: {
    input (v) {
      this.valid = v.trim().length > 0
    }
  },
  mounted () {
  },
  methods: {
    ...mapMutations([
      'SET_POPUP_HEADER_MAIN'
    ]),
    mobileDeleteAuth () {
      console.log('권한에러 액션버튼 진입')
      this.SET_POPUP_HEADER_MAIN(false)
      if (sessionStorage.getItem('userAgent') === 'mobile') {
        const url = 'thanq://logout'
        document.location.href = url
      }
      if (getCookie('token') === undefined) {
        this.$router.push(this.mobileLink)
        sessionStorage.removeItem('authErrorCause')
      } else {
        sessionStorage.setItem('authErrorCause', 'mutated')
        window.location.reload()
      }
    },
    async mobileAction () {
      this.SET_POPUP_HEADER_MAIN(false)
      console.log('링크보내기')
      document.location.href = this.mobileLink
      await this.exit()
    },
    exit () {
      console.log('어플 종료하기')
      const url = 'thanq://appClose'
      document.location.href = url
    },
    addPopup () {
      this.SET_POPUP_HEADER_MAIN(false)
    },
    btnMove () {
      this.$router.push(this.nextLink)
    },
    btnMoveDeploy () {
      this.$router.push(this.nextLink)
      this.SET_POPUP_HEADER_MAIN(false)
    },
    btnMoveClosed () {
      this.$router.push(this.nextLink)
      this.SET_POPUP_HEADER_MAIN(false)
    },
    closeAction () {
      this.SET_POPUP_HEADER_MAIN(false)
      this.$router.push(this.closeLink)
    }
  }
}
</script>

<style>
</style>
